import request from "superagent";
import { getAuthHeader } from "src/utils/superagent";
import {
  IChargeBreakdown,
  ListNegotiationsCustomField,
  Negotiation,
  NegotiationWithShiftDetails,
} from "src/components/RateNegotiationModal/interfaces";
import qs from "qs";
import { showErrorToast } from "@src/appV2/lib/Notifications";

interface IGetNegotiations {
  shiftIds: string[];
  workplaceUserIds: string[];
  customFields?: ListNegotiationsCustomField[];
}

const getNegotiations = async ({
  shiftIds,
  workplaceUserIds,
  customFields,
}: IGetNegotiations): Promise<Negotiation[]> => {
  try {
    return (
      await request
        .get(`${global.api}/negotiation/list`)
        .set(await getAuthHeader())
        .query(
          qs.stringify(
            {
              filter: {
                shiftIds,
                workplaceUserIds,
              },
              customFields,
            },
            { arrayFormat: "brackets" }
          )
        )
    ).body;
  } catch (err) {
    showErrorToast(`Error fetching negotiation: ${(err as Error).message}`);
    return [];
  }
};

const getNegotiationWithId = async (id: string): Promise<Negotiation | undefined> => {
  try {
    return (await request.get(`${global.api}/negotiation/${id}`).set(await getAuthHeader())).body
      .negotiation;
  } catch (err) {
    showErrorToast(`Error fetching negotiation: ${(err as Error).message}`);
  }
};

const getNegotiationByIdWithShiftDetails = async (
  id: string
): Promise<NegotiationWithShiftDetails> => {
  return (
    await request.get(`${global.api}/negotiation/${id}/shift-details`).set(await getAuthHeader())
  ).body;
};

const acceptNegotiation = async (id: string): Promise<Negotiation> => {
  return (await request.post(`${global.api}/negotiation/accept/${id}`).set(await getAuthHeader()))
    .body.negotiation;
};

const endNegotiation = async (id: string): Promise<Negotiation> => {
  return (await request.patch(`${global.api}/negotiation/${id}/reject`).set(await getAuthHeader()))
    .body.negotiation;
};

const getChargeBreakdown = async (id: string, rate?: number): Promise<IChargeBreakdown> => {
  return (
    await request
      .get(`${global.api}/negotiation/${id}/total-charge`)
      .set(await getAuthHeader())
      .query({ payRate: rate })
  ).body;
};

const propose = async (id: string, rate: number): Promise<Negotiation> => {
  return (
    await request
      .patch(`${global.api}/negotiation/${id}/propose`)
      .set(await getAuthHeader())
      .send({
        payRate: rate,
      })
  ).body.negotiation;
};

const closeOpenNegotiationsForFacility = async (facilityId: string): Promise<number> => {
  return (
    await request
      .post(`${global.api}/negotiation/facilityCloseNegotiations`)
      .set(await getAuthHeader())
      .send({
        facilityId,
      })
  ).body.countOfNegotiationsClosed;
};

export {
  closeOpenNegotiationsForFacility,
  getNegotiations,
  getNegotiationWithId,
  acceptNegotiation,
  endNegotiation,
  getChargeBreakdown,
  propose,
  getNegotiationByIdWithShiftDetails,
};
